import ChartActionId from '@/common/enums/chart-action-id.enum';
import DownloadActionType from '@/common/enums/chart-download-action.enum';
import ChartGroupActionType from '@/common/enums/chart-group-action-type.enum';
import ChartAction from '@/common/models/chart/ChartAction';
import ChartGroupAction from '@/common/models/chart/ChartGroupAction';
import i18n from '@/vueI18n';

export default class ChartDownloadGroupActionsUtils {
  static get defaultOptions(): ChartAction[] {
    return [
      new ChartAction(DownloadActionType.IMAGE, false, i18n.global.t('messages.chartGroupActionDownloadImage'), 0),
      new ChartAction(DownloadActionType.CSV, false, i18n.global.t('messages.chartGroupActionDownloadCsv'), 0),
      new ChartAction(DownloadActionType.EXCEL, false, i18n.global.t('messages.chartGroupActionDownloadExcel'), 0),
    ];
  }

  static getChartDownloadGroupActions(
    rank: number,
    isHighlighted: boolean,
    optionList?: DownloadActionType[],
  ): ChartGroupAction {
    const options = optionList?.length
      ? optionList.map((o) => ({ ...ChartDownloadGroupActionsUtils.defaultOptions.find((d) => d.id === o) }))
      : ChartDownloadGroupActionsUtils.defaultOptions;

    return new ChartGroupAction(
      ChartActionId.DOWNLOAD,
      ChartGroupActionType.CLICKABLE,
      i18n.global.t('messages.chartGroupActionDownload'),
      rank,
      options,
      isHighlighted,
      false,
    );
  }

  static get DefaultChartDownloadOptions(): ChartGroupAction {
    return ChartDownloadGroupActionsUtils.getChartDownloadGroupActions(99, false, [
      DownloadActionType.IMAGE,
      DownloadActionType.CSV,
      DownloadActionType.EXCEL,
    ]);
  }
}
